import { I18n } from '@calendly/i18n';
import { IconMenu2 } from '@calendly/ui/components/glyphs/IconMenu2';
import { IconButton } from '@calendly/ui/components/icon-button';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDispatch } from 'react-redux';
import { AiChatDiscoveryTopButton, useAiChatDiscoveryMiEligible } from 'features/agent_hub';
import { setOpen } from 'features/left_navigation';
import { HelpCenterMenu } from './HelpCenterMenu';
import { DebugToolsHost } from '../debug_tools/DebugToolsHost';
const appBarCss = "a10cxdqu";
const appBarLeftCss = "a1ykrgyq";
const appBarRightCss = "aazmhra";
const hamburgerCss = "h166j71i";

/** Left slot of the app bar. Renders a hamburger icon button on mobile (≤895px) to open navigation. */
const AppBarLeft = () => {
  const dispatch = useDispatch();
  return <div className={appBarLeftCss}>
      <span className={hamburgerCss}>
        <IconButton size="small" title={I18n.t('publisher.app_shell.app_bar.menu')} onClick={() => dispatch(setOpen(true))}>
          <UiIcon icon={IconMenu2} size="medium" />
        </IconButton>
      </span>
    </div>;
};

/**
 * Right slot of the app bar. Contains global actions available on every page:
 * - `HelpCenterMenu` — support links and actions
 * - `NotificationsMenu` — user notifications (badge count TBD)
 * - Ask Callie button — toggles the AI chat right rail
 */
const AppBarRight = () => {
  const isAiChatDiscoveryEligible = useAiChatDiscoveryMiEligible();
  return <div className={appBarRightCss}>
      <DebugToolsHost />
      <HelpCenterMenu />
      {isAiChatDiscoveryEligible && <AiChatDiscoveryTopButton labelVariant="app_bar" size="small" />}
    </div>;
};

/**
 * Top chrome bar rendered in the `app-bar` grid area of `AppShell`.
 * Composed of `AppBarLeft` (mobile nav trigger) and `AppBarRight` (global actions).
 */
export const AppBar = () => <div className={appBarCss}>
    <AppBarLeft />
    <AppBarRight />
  </div>;

require("./AppBar.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppBar.tsx");